import * as React from 'react'
import './CustomOptionsComponent.css';

const CustomOptionsComponent = ({ options, onOptionClick }) => {
    return (
        <div className="custom-options-container">
            <p className="intro-text">
                Hello! I can help you simplify
                complexities of Union Budget,
                choose from trending questions,
                or
                ask me anything.
            </p>
            {options.map((option, index) => (
                <div key={index} className="option-box" onClick={() => onOptionClick(option.text)}>
                    <p className="option-text">{option.text}</p>
                    {option.subtext && <p className="option-subtext">{option.subtext}</p>}
                </div>
            ))}
        </div>
    );
};

export default CustomOptionsComponent;
